/* eslint-disable @typescript-eslint/no-unsafe-call */
import { useEffect, useState } from "react";
export const filter = (query, respAction) => {
    return respAction === null || respAction === void 0 ? void 0 : respAction.Values.filter((item) => {
        return item.DisplayLabel.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    });
};
export const getData = (query, respAction) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(filter(query, respAction));
        }, 200);
    });
};
const useQuery = ({ query = "" }, respAction) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        void getData(query, respAction).then((response) => {
            setData(response);
            setLoading(false);
        });
    }, [query, respAction]);
    return {
        data,
        loading,
    };
};
export default useQuery;
